export default __webpack_public_path__ + "static/output-a936dd5f990b3c7019d1b0dfae12bfa3.webm";